import { Injectable, inject } from '@angular/core'
import { ApiClient } from '@ftr/api-shared'
import { Uuid } from '@ftr/contracts/type/shared'
import { Observable } from 'rxjs'
import { DigitalJusticeApiClientFactory } from './digital-justice-api-client.factory'

@Injectable()
export class DigitalJusticeApiClientSetupService {
  protected readonly digitalJusticeApiClientFactory = inject(DigitalJusticeApiClientFactory)

  digitalJusticeApiPath: string
  readonly digitalJusticeApiClientMap = new Map<string, Observable<ApiClient>>()

  digitalJusticeApiClient(path: string, courtSystemId: Uuid, region?: string): Observable<ApiClient> {
    const uniqueKey = `${path}-${courtSystemId}`
    if (!this.digitalJusticeApiClientMap.has(uniqueKey)) {
      // Note on testing: digitalJusticeApiClientFactory.build needs to return from([apiClient.object]),
      // not of(apiClient.object)
      this.digitalJusticeApiClientMap.set(
        uniqueKey,
        this.digitalJusticeApiClientFactory.build(path, courtSystemId, region),
      )
    }
    return this.digitalJusticeApiClientMap.get(uniqueKey)!
  }

  getWebEndpoint(courtSystemId: Uuid): Observable<string> {
    return this.digitalJusticeApiClientFactory.getWebEndpoint(courtSystemId)
  }
}
